import { Creator, CustomBranding } from "../types"

const defaultCustomBranding: CustomBranding = {
  custom_branding: false,
  custom_allow_bey_branding: true,
  custom_title: "",
  custom_favicon_url: "",
  custom_logo_url: "",
  custom_background_url: "",
  custom_brand_color: "",
  custom_accent_color: "",
  custom_font_color: "",
  custom_font_family: "",
  custom_font_url: "",
  custom_brand_website: "",
  custom_brand_email: "",
  custom_brand_button_text: "",
  custom_brand_button_url: "",
  custom_enable_contact_form: false,
}

export const getDefaultCustomBranding = (): CustomBranding => {
  return defaultCustomBranding
}

export const getCreatorCustomBranding = (creator: Creator): CustomBranding => {
  if (!creator) return defaultCustomBranding

  const customBranding: CustomBranding = { ...defaultCustomBranding }
  for (const key in creator) {
    if (key.startsWith("custom_")) {
      customBranding[key] = creator[key]
    }
  }
  return customBranding
}
